import React from 'react';

export default function BairesDevLogo() {
  return (
    <svg width="28" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.8108 0.20166C25.4704 0.20166 31.6799 6.41113 31.6799 14.0708C31.6799 21.7304 25.4704 27.9399 17.8108 27.9399V0.20166Z"
        fill="#F66135"
      />
      <path
        d="M7.99445 0C15.3286 2.20855 19.4849 9.94218 17.2763 17.2763C15.0696 24.6104 7.3341 28.7667 0 26.5581L7.99445 0Z"
        fill="#F66135"
      />
    </svg>
  );
}
